import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { InlineNotification, ModalWindow, Select, Text, TextArea, useLocalizeMessage, useToastNotification, } from 'libs.nucleus';
import { DCR_STATUS_NOTES, DCR_STATUS_OPTIONS } from '../../constants';
import { useDcrApiContext } from '../../contexts';
import { useChangeDcrStatus } from '../../hooks';
import { EDcrStatus } from '../../types';
import { DcrStatusBadge } from '../dcr_status_badge';
export const DcrStatusModal = ({ record, onClose }) => {
    const translate = useLocalizeMessage();
    const { addNotification } = useToastNotification();
    const apiContext = useDcrApiContext();
    const currentStatus = record.dcr_intake__status;
    const [status, setStatus] = useState(currentStatus);
    const [reason, setReason] = useState('');
    const changeStatus = useChangeDcrStatus(apiContext);
    const cannedNote = DCR_STATUS_NOTES[status];
    const note = cannedNote ?? reason.trim();
    const canSubmit = status !== currentStatus && !!note && !changeStatus.isPending;
    const handleSubmit = async () => {
        try {
            await changeStatus.mutateAsync({ dcrId: record._id, status, note });
            addNotification({ title: translate('Status changed'), type: 'success' });
            onClose();
        }
        catch (error) {
            addNotification({
                title: translate('Could not change the status'),
                subtitle: error?.response?.data?.reason ??
                    translate('Try again in a moment.'),
                type: 'error',
            });
        }
    };
    return (_jsx(ModalWindow, { isOpen: true, closeWindow: onClose, width: 'sm', title: translate('Change status'), subtitle: record.dcr_intake__number, footerPrimaryActionButton: {
            label: translate('Change status'),
            onClick: handleSubmit,
            disabled: !canSubmit,
        }, footerSecondaryActionButtons: [{ label: translate('Cancel'), onClick: onClose, variant: 'secondary' }], dataTestId: 'dcr-status-modal', children: _jsxs("div", { className: 'flex flex-col gap-4', children: [_jsxs("div", { className: 'flex flex-col gap-1', children: [_jsx(Text, { size: 'sm', className: 'font-medium', children: translate('Current status') }), _jsx(DcrStatusBadge, { status: currentStatus })] }), _jsx(Select, { label: translate('New status'), required: true, options: DCR_STATUS_OPTIONS, value: DCR_STATUS_OPTIONS.find((option) => option.value === status), onChange: (option) => {
                        setStatus(option?.value ?? currentStatus);
                        setReason('');
                    }, width: 'full', dataTestId: 'dcr-status-select' }), cannedNote ? (_jsx(InlineNotification, { type: 'info', title: translate('Status note'), subtitle: translate(cannedNote) })) : (_jsx(TextArea, { id: 'dcr-status-note', label: status === EDcrStatus.DECLINED ? translate('Reason for declining') : translate('Reason for cancelling'), required: true, placeholder: translate('Explain why, so the site understands what happened to the request.'), value: reason, onChange: (event) => setReason(event.target.value), width: 'full', autogrow: true }))] }) }));
};
